// Production uses runtime values; local builds fall back to CRA's embedded env.
// CRA only embeds explicitly referenced environment variables.
const BUILD_TIME_ENV = {
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_AZURE_CLIENT_ID: process.env.REACT_APP_AZURE_CLIENT_ID,
  REACT_APP_AZURE_TENANT_ID: process.env.REACT_APP_AZURE_TENANT_ID,
  REACT_APP_FRONT_END_URL: process.env.REACT_APP_FRONT_END_URL,
  REACT_APP_STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
  REACT_APP_THEME: process.env.REACT_APP_THEME
}

export function getRuntimeEnv(name, fallback = undefined) {
  const runtime =
    typeof window !== 'undefined' && window.__CITADEL_RUNTIME__ && typeof window.__CITADEL_RUNTIME__ === 'object'
      ? window.__CITADEL_RUNTIME__
      : undefined

  if (runtime && runtime[name] !== undefined && runtime[name] !== null && String(runtime[name]) !== '') {
    return String(runtime[name])
  }

  const buildTimeValue = BUILD_TIME_ENV[name]
  if (buildTimeValue !== undefined && buildTimeValue !== null && buildTimeValue !== '') {
    return buildTimeValue
  }

  return fallback
}

export function getRuntimeTheme() {
  return getRuntimeEnv('REACT_APP_THEME', 'citadel')
}
